module.exports = "/src/views/games/other/images/roles/civilian_man.png";